// AUTOGENERATED
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dValue from "../Data.Value/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dInternal$dStringify from "../Foreign.Internal.Stringify/index.js";
const AddressExtraIsSymbol = {reflectSymbol: () => "AddressExtra"};
const AddressExtra = x => x;
const toFillFormTypeAddressExtr = {fillFormDataType: v => "unknown"};
const newtypeAddressExtra_ = {Coercible0: () => {}};
const eqAddressExtra = {eq: x => y => Foreign$dInternal$dStringify.unsafeStringify(x) === Foreign$dInternal$dStringify.unsafeStringify(y)};
const genericAddressExtra = {to: x => x, from: x => x};
const showAddressExtra = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dValue.showValue.show(v)]})(AddressExtraIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeAddressExtra = {unsafeDecode: x => x};
const encodeAddressExtra = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericAddressExtra)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(AddressExtraIsSymbol)({
    encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
  }))
};
const decodeAddressExtra = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericAddressExtra)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(AddressExtraIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign$dGeneric$dClass.applicativeExceptT.pure}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  AddressExtra,
  AddressExtraIsSymbol,
  decodeAddressExtra,
  encodeAddressExtra,
  eqAddressExtra,
  genericAddressExtra,
  newtypeAddressExtra_,
  showAddressExtra,
  toFillFormTypeAddressExtr,
  unscrambleDecodeAddressExtra
};
